import AdminReportProspects from "../../components/Prospects/AdminReportProspects";
import LoadBaseProspects from "../../components/Prospects/LoadBaseProspects";
import ParamsProspects  from "../../components/Prospects/ParamsProspects";
import AssignProspects from "../../components/Prospects/AssignProspects";

export default function AdminSections({ activeSection,campaigns }) {
    switch (activeSection) {
        case "metricas":
            return <AdminReportProspects />;
        case "parametros":
            return <ParamsProspects campaigns={campaigns} />;
        case "cargarBase":
            return <LoadBaseProspects/>;
        case "asignar":
            return <AssignProspects campaigns={campaigns}/>;
        case "reportes":
            return <p>Tabla de reportes</p>;
        default:
            return <AdminReportProspects />;
    }
}
